import { render, staticRenderFns } from "./ThresholdsSetttingsView.vue?vue&type=template&id=e18ab2de&scoped=true"
import script from "./ThresholdsSetttingsView.vue?vue&type=script&lang=js"
export * from "./ThresholdsSetttingsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e18ab2de",
  null
  
)

export default component.exports